


Q.ErrorHandling.showServiceError = function (error: any) {
    var id = 'ErrorDialog_' + new Date().getTime();

    function getSiteExternalUrl() {
        return window.location.href.split('/').slice(0, 3).join('/');
    }

    let msg: string;
    if (error == null) {
        msg = '??ERROR??';
    }
    else {
        msg = error.Message;
        if (msg == null) {
            msg = error.Code;
        }
    }

    Q.alert(`${error?.Details ? `<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#${id}_Error">Error</a></li>
  <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#${id}_Details">Details</a></li>
</ul>` : ''}
<div class="tab-content">
  <div id="${id}_Error" class="tab-pane fade show active error-pane">
    ${error?.ErrorId ? `<h6 class="error-id"><label>Error ID:</label><span> ${Q.htmlEncode(error.ErrorId)}</span></h6>` : ''}
    <div class="message-text">${Q.htmlEncode(msg)}</div>
  </div>
  ${error?.Details ? `<div id="${id}_Details" class="tab-pane fade details">${Q.htmlEncode((error as any)?.Details)}</div>` : ''}
</div>`, <any>{
            dialogClass: "s-AlertDialog s-MatrixErrorDialog", 
            htmlEncode: false,
            width: '60%',
            onOpen: function () {
                var uidlg = $(this).closest('.ui-dialog');
                uidlg.find('.copy-button').off('click').click(() => {
                    var copyCommand = null;
                    if (navigator.clipboard)
                        copyCommand = (s: string) => navigator.clipboard.writeText(s);

                    if (!copyCommand && document.queryCommandSupported('copy')) {
                        copyCommand = (s: string) => {
                            var fakeElement = document.createElement('textarea');
                            fakeElement.style.position = 'absolute';
                            fakeElement.style.left = '-9999px';
                            fakeElement.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
                            fakeElement.setAttribute('readonly', '');
                            fakeElement.value = s;
                            document.body.append(fakeElement);
                            fakeElement.select();
                            document.execCommand("copy");
                            fakeElement.remove();
                        }
                    }

                    if (!copyCommand) {
                        Q.notifyError("Copy to clipboard is not supported!");
                        return;
                    }

                    var text = uidlg.find('.tab-pane').first().text();
                    try {
                        copyCommand(text);
                        Q.notifySuccess("Copied error to clipboard.");
                    } catch (error) {
                        Q.notifyError("Sorry, an error while trying to copy to clipboard!");
                    }
                });

                var font = "font-family: Tahoma, Arial, Helvetica; font-size: 13px;";

                uidlg.find('.ticket-button').off('click').click(() => {
                    Matrix.Administration.SupportTicketService.SendEmail({
                        Subject: 'Matrix Portal Error Support Request',
                        Body: `<html>
<body style="${font}">
    <p style="${font}"><b>URL:</b> ${Q.htmlEncode(window.location)}</p>
    <p></p>
    <p style="${font}"><b>Username:</b> ${Q.Authorization.username}</p>
    <p></p>
    <p style="${font}"><b>Error ID: </b><a href="${Q.attrEncode(getSiteExternalUrl())}/Administration/ExceptionLog/info?guid=${Q.attrEncode(encodeURIComponent(error.ErrorId))}">${Q.htmlEncode(error.ErrorId)}</a></p>
    <p></p>
    <p style="${font}">
        <b>Message:</b><br/>
        <pre style="${font}">${Q.htmlEncode((error as any)?.Message)}</pre>
    </p>
    <p style="${font}"><b>Details:</b><br/>
<pre>${Q.htmlEncode((error as any)?.Details)}</pre>
    </p>
</body>
</html>`
                    },
                        () => {
                            Q.notifySuccess('Opening support ticket via e-mail is successfull.');
                            $(this).dialog('close');
                        });
                });
            },
            buttons: [
                {
                    text: 'Copy',
                    cssClass: 'copy-button'
                },
                {
                    text: 'Open Support Ticket',
                    cssClass: 'ticket-button',
                },
                {
                    text: Q.text('Dialogs.OkButton'),
                    result: 'ok'
                }
            ]
    });

}